import { Switch as MantineSwitch } from "@mantine/core";

export const Switch = MantineSwitch;
